import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { FormattedMessage } from '@flipster/i18n';
import { Tooltip } from '@flipster/react/design-system/tooltip';
import Formatted from '@flipster/react/design-utils/formatted';
import InformationCircleIcon from '@flipster/react/icon/generated/InformationCircleIcon';
import { css } from '@flipster/styled-system/css';
import { hstack, stack } from '@flipster/styled-system/patterns';
import { token } from '@flipster/styled-system/tokens';
import { numberFormatter } from '@flipster/utils/num';

import { ProfileIcon } from '../../../../shared/profile-icon';
import { copyTradingSettingsBunja } from '../../state';

export const HeaderSection = () => {
  const { portfolioAtom } = useBunja(copyTradingSettingsBunja);
  const portfolio = useAtomValue(portfolioAtom);
  return (
    <div className={hstack({ gap: 16 })}>
      <ProfileIcon profileIconUrl={portfolio?.profileIconUrl} size={60} />
      <div className={stack({ gap: 8 })}>
        <p className={css({ textStyle: 'Title/XS', color: 'content.default.level-5' })}>{portfolio?.nickname}</p>
        <div className={hstack({ gap: 4, textStyle: 'Text/M/Regular', color: 'content.default.level-3' })}>
          <p>
            <FormattedMessage id='Copy.r251107.Profit_sharing' />
          </p>
          <Formatted.Percent value={portfolio?.profitSharingPct} css={{ color: 'content.default.level-5' }} />
          <Tooltip.Root placement='right'>
            <Tooltip.Trigger>
              <InformationCircleIcon size={16} color={token('colors.content.default.level-1')} />
            </Tooltip.Trigger>
            <Tooltip.Content bottomSheetTitle={<FormattedMessage id='Copy.r251107.Profit_sharing' />}>
              <FormattedMessage
                id='Copy.r251107.Profit_sharing_tooltip_percent_total_pnl_paid_master_weekly'
                values={{ percent: numberFormatter(portfolio?.profitSharingPct, { precision: 2 }) + '%' }}
              />
            </Tooltip.Content>
          </Tooltip.Root>
        </div>
      </div>
    </div>
  );
};
